// 流水的前后余额比 couponType 更可靠：部分消费记录的 couponType 也是 1。
export function formatUserPowerChange(log) {
  const before = Number(log.totalPower)
  const after = Number(log.balancePower)
  if (log.totalPower != null && log.balancePower != null && Number.isFinite(before) && Number.isFinite(after)) {
    const delta = after - before
    if (delta === 0) return '--'
    return `${delta > 0 ? '+' : '-'}${Number(Math.abs(delta).toFixed(8))}`
  }

  if (log.changeAmount == null || !Number.isFinite(Number(log.changeAmount))) return '--'
  const amount = Math.abs(Number(log.changeAmount))
  const changeType = Number(log.changeType)
  const couponType = Number(log.couponType)
  if (changeType === 2) return `-${amount}`
  if (changeType === 1 || changeType === 3 || changeType === 4) return `+${amount}`
  if (changeType === 5 && couponType === 2) return `-${amount}`
  if (changeType === 5 && couponType === 1) return `+${amount}`
  return '--'
}

export function formatUserPowerBalance(log) {
  if (log.balancePower == null || log.balancePower === '') return '--'
  const balance = Number(log.balancePower)
  return Number.isFinite(balance) ? log.balancePower : '--'
}
